import { environment } from 'environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import { Connection, Proxy, hubConnection } from 'signalr-no-jquery';

@Injectable({
  providedIn: 'root'
})
export class ScheduleHubService {
  private connection: Connection;
  private proxy: Proxy;
  public connectionExists: Boolean;
  public scheduleUpdateEvent = new EventEmitter<any>();

  constructor(
  ) {
    console.log('ScheduleHub Started...');
    this.connectionExists = false;
    this.connection = hubConnection(environment.api + '/signalr/', { useDefaultPath: false, logging: true });
    this.proxy = this.connection.createHubProxy('scheduleHub');
    this.registerOnServerEvents();
  }

  public start(clubId: string) {
    this.startConnection(clubId).then();
  }

  private async startConnection(clubId: string): Promise<void> {
    if (this.connectionExists) {
      this.connection.stop();
    }
    try {
      await this.connection.start({ transport: 'serverSentEvents' });
      await this.proxy.invoke('subscribeScheduleHub', clubId);
      this.connectionExists = true;
    } catch (error) {
      console.error('*** Could not connect ' + error);
    }
  }

  private registerOnServerEvents(): void {
    this.proxy.off('ScheduleUpdateEvent', (res) => this.onUpdateEvent(res));
    this.proxy.on('ScheduleUpdateEvent', (res) => this.onUpdateEvent(res));
  }

  private onUpdateEvent(res) {
    this.scheduleUpdateEvent.emit(JSON.parse(res))
  };
}
